import {
  categories_tab,
  menus_tab,
  modifier_groups_tab,
  modifiers_tab,
  products_tab,
} from '../../../../../../views/menu/smart-pricing';
import { SMART_PRICING_RESOURCE_TYPE } from '../../../../../../services/exports/Constants';

export default {
  title: 'Inteligentne ceny',
  master_title: 'Tryb marki - Inteligentne ceny',
  sections: {
    how_it_works: {
      title: 'Jak to działa',
      description:
        'Inteligentne ceny to funkcja umożliwiająca kontrolowanie cen w zależności od metody zamówienia wybranej przez klienta. Obejmuje wiele przypadków użycia, takich jak obniżka ceny przy odbiorze, podwyżka przy dostawie, rabat na sezonowe menu itp. Reguły można tworzyć na wielu poziomach (Globalny, Menu, Kategoria, Produkt, Grupa modyfikatorów, Modyfikator). Poziomy działają jak drzewo — wyższy wpływa na niższe. Jednocześnie reguła niższego poziomu ma wyższy priorytet (np. reguła 5% rabatu przy odbiorze dla danej kategorii nadpisuje globalny rabat 15% przy odbiorze dla jej produktów).',
    },
  },
  tabs: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Reguły globalne',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Reguły globalne',
    [menus_tab]: 'Reguły menu',
    [categories_tab]: 'Reguły kategorii',
    [products_tab]: 'Reguły produktów',
    [modifier_groups_tab]: 'Reguły grup modyfikatorów',
    [modifiers_tab]: 'Reguły modyfikatorów',
  },
  fields: {
    name: 'Nazwa',
    order_methods: 'Metody zamówienia',
    modifier: 'Modyfikator',
    image: 'Obraz',
    actions: 'Akcje',
  },
  labels: {
    absolute: 'Bezwzględna',
  },
  buttons: {
    add_rule: 'Dodaj regułę',
    edit: 'Edytuj',
    delete: 'Usuń ({{count}})',
    images: 'Zarządzaj zdjęciem',
  },
  popups: {
    delete_rule: {
      title: 'Na pewno usunąć?',
    },
  },
  toasts: {
    failed_to_load_data: 'Nie udało się wczytać danych',
    failed_to_delete: 'Nie udało się usunąć reguł',
    deleted_successfully: 'Reguły zostały usunięte',
  },
};
